/**
 * Component Registry
 *
 * Maps route paths to their React components. This is the ONLY file a
 * developer needs to touch when creating a new page/module.
 *
 * The menu structure (names, icons, order, hierarchy) comes from the backend
 * via GET /b2b/admin/modules. This file only tells React WHAT to render
 * at each path.
 *
 * To add a new module:
 * 1. Create your component (e.g. src/pages/NewFeature/NewFeaturePage.jsx)
 * 2. Import it here
 * 3. Add the path mapping: '/path/from/backend': NewFeaturePage
 * 4. In "Gestión de Módulos" (admin), add the menu entry with that path
 * 5. In "Accesos del Sistema" (admin), enable it for the users who need it
 */

import AsyncDocumentsReport from '../pages/Reports/AsyncDocuments';
import Teams from '../pages/Teams/Teams';
import Roles from '../pages/Admin/Roles';
import ModuleManagement from '../pages/Admin/ModuleManagement';
import MembershipNew from '../pages/B2b/ManagmentMembership/Altas/MembershipNew';
import MembershipReport from '../pages/B2b/ManagmentMembership/AltasReport/MembershipTablePage';
import ModificationsPage from '../pages/B2b/ManagmentMembership/Modificaciones/ModificationsPage';
import ModificationsReport from '../pages/B2b/ManagmentMembership/ModificacionesReport/ModificationsReportPage';
import ContractsListPage from '../pages/B2b/Contratos/Listado/ContractsListPage';
import ContractsUsagePage from '../pages/B2b/Contratos/Consumo/ContractsUsagePage';
import IAWelcome from '../pages/IA/ia';
import PRD from '../pages/IA/prd/prd';

const componentRegistry = {
    '/reportes/escolar/asincronicos': AsyncDocumentsReport,
    '/b2b/gestion/altas': MembershipNew,
    '/b2b/gestion/reporte': MembershipReport,
    '/b2b/modificaciones/gestion': ModificationsPage,
    '/b2b/modificaciones/reporte': ModificationsReport,
    '/b2b/contratos/listado': ContractsListPage,
    '/b2b/contratos/consumo': ContractsUsagePage,
    '/teams/reuniones': Teams,
    '/teams/calendario': Teams,
    '/admin/administracion/roles': Roles,
    '/admin/administracion/gestion-menu': ModuleManagement,
    '/ia': IAWelcome,
    '/ia/prd': PRD,
};

/**
 * Lista de paths que TIENEN un componente registrado. Se usa en
 * "Gestión de Módulos" para ofrecer solo rutas válidas al dar de alta un
 * ítem navegable, garantizando el match entre lo guardado en BD y el código.
 */
export const registeredPaths = Object.keys(componentRegistry);

export default componentRegistry;
